var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _vm.linkAccountFailed
            ? _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-text", [
                        _vm._v(" Please, contact Your affiliate manager. ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("account-information", {
                      attrs: {
                        loading: _vm.loading
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c(
                      "v-skeleton-loader",
                      {
                        attrs: {
                          loading: _vm.loading,
                          type: "article"
                        }
                      },
                      [
                        _c("account-overview", {
                          attrs: {
                            type: "month",
                            title: "Statistics"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("payment-method", {
                      attrs: {
                        loading: _vm.loading
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("classification", {
                      attrs: {
                        loading: _vm.loading
                      }
                    })
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }